import React from "react";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";

export const ChiSiamo = () => {
  return (
    <div className="flex flex-col items-center bg-white w-full h-full">
      <Navbar />

      {/* Immagine sotto la Navbar */}
      <div className="w-full border-[15px] md:border-[30px] border-white">
        <img
          src="../img/Sfondovecchioorologi.png"
          alt="Storia dell'oreficeria Strippoli - vecchi orologi"
          className="w-full object-cover h-auto max-h-[200px] md:max-h-[300px]"
        />
      </div>

      {/* Sezione contenuto */}
      <main className="flex flex-col items-center w-full px-4 md:px-[8%] lg:px-[10%] py-8 md:py-12 lg:py-[50px]">
        <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-6 md:mb-8 font-elegant text-center">Chi Siamo</h1>
        <p className="text-base md:text-lg lg:text-xl xl:text-2xl text-gray-700 text-center leading-relaxed md:leading-8 font-elegant max-w-4xl">
          L'oreficeria Strippoli di Via Lecco nasce nell'immediato dopoguerra
          dalla volontà e dall'esperienza del Sig. Vincenzo. La passione
          dell'orologeria viene poi trasmessa al figlio Aldo che prosegue
          nell'attività familiare e comincia a espandersi anche nel settore
          dell'oreficeria.
        </p>

        {/* Sezione Mission e Vision */}
        <div className="flex flex-col md:flex-row justify-center gap-6 md:gap-12 lg:gap-[50px] mt-8 md:mt-[40px]">
          {/* Puoi aggiungere contenuti opzionali per mission e vision qui */}
        </div>
      </main>

      <Footer />
    </div>
  );
};
